<div class="login-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>Smart Fix Admin System</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="button-container">
        <button mat-raised-button color="primary" (click)="login()">
          Login
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
